import React from "react";
import './TypingIndicator.css'

export default function TypingIndicator() {
  return (
    <div className="typing-indicator">
      <div className="dot dot-1"></div>
      <div className="dot dot-2"></div>
      <div className="dot dot-3"></div>
    </div>
  );
}
